import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const SectionCard = ({ title, subtitle, icon: Icon, headerAction, className, bodyClassName, children }) => (
	<section className={twMerge('bg-white rounded-card border border-bgBase-500 overflow-hidden', className)}>
		<div className="flex items-center justify-between gap-4 px-4 py-3 border-b border-bgBase-500 bg-bgBase-300">
			<div className="flex items-center gap-2.5 min-w-0">
				{Icon && <Icon className="w-4 h-4 text-primary-500 flex-shrink-0" />}
				<div className="min-w-0">
					<h2 className="text-sm font-bold text-text tracking-tight">{title}</h2>
					{subtitle && <p className="text-[11px] text-bgBase-800 font-medium mt-0.5">{subtitle}</p>}
				</div>
			</div>
			{headerAction}
		</div>
		<div className={twMerge('p-4', bodyClassName)}>{children}</div>
	</section>
);

SectionCard.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string,
	icon: PropTypes.elementType,
	headerAction: PropTypes.node,
	className: PropTypes.string,
	bodyClassName: PropTypes.string,
	children: PropTypes.node,
};

export default SectionCard;
